// extracted by mini-css-extract-plugin
export default {"dot":"MultiplayerCursor_dot__NE6c0"};